import {
  getComplementsPlacementId,
  getSubstitutesPlacementId,
  getSuggestionsPlacementId,
} from 'features/related-products/selectors';
import { useSelector } from 'react-redux';

export const useRecoblockSelectors = () => {
  const suggestionsPlacementId = useSelector(getSuggestionsPlacementId);
  const complementsPlacementId = useSelector(getComplementsPlacementId);
  const substitutesPlacementId = useSelector(getSubstitutesPlacementId);

  return { suggestionsPlacementId, complementsPlacementId, substitutesPlacementId };
};
